import PropTypes from 'prop-types';
import React from 'react';
import config from 'config';
import Button from '@mulesoft/anypoint-components/lib/Button';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import CloseIcon from '@mulesoft/anypoint-icons/lib/svg/close-small.svg';
import * as eventHandlerUtils from '~/utils/eventHandlers';
import styles from './OmniBanner.css';

const componentName = 'OmniBanner';

const OmniBanner = ({ onClose, trackOnClose }) => {
  const [isVisible, setVisibility] = React.useState(true);

  const handleClose = () => {
    setVisibility(false);
    if (trackOnClose) {
      trackOnClose(componentName);
    }
    if (onClose) {
      onClose();
    }
  };

  const handleGoToOmni = () => {
    const omniHost = config.omni?.host || 'omni.mulesoft.com';

    window.open(`https://${omniHost}/agents`, '_blank', 'noopener,noreferrer');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-test-id="omni-banner-wrapper">
      <div className={styles.banner} data-test-id="omni-banner-banner">
        <div
          className={styles['dismiss-row']}
          data-test-id="omni-banner-dismiss-row"
        >
          <Icon
            data-test-id="close-omni-banner"
            role="button"
            aria-label="Close Omni banner"
            tabIndex="0"
            className={styles['close-icon']}
            size="xs"
            onClick={handleClose}
            onKeyDown={eventHandlerUtils.onEnterKey(handleClose)}
          >
            <CloseIcon />
          </Icon>
        </div>
        <div className={styles.content} data-test-id="omni-banner-content">
          <div className={styles.text} data-test-id="omni-banner-text">
            <div className={styles.title} data-test-id="omni-banner-title">
              Manage your portfolio of services
            </div>
            <p
              className={styles.description}
              data-test-id="omni-banner-description"
            >
              Simplify how you manage your services with the new portfolio.
              Manage agents, MCPs, and APIs in a single, consolidated view.
            </p>
          </div>
          <div className={styles.cta} data-test-id="omni-banner-cta">
            <Button
              testId="omni-banner-go-to-omni-button"
              onClick={handleGoToOmni}
            >
              Go to enhanced experience&nbsp;
              <Icon
                name="open"
                size="xs"
                className={styles['button-icon']}
                isDecorative
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

OmniBanner.displayName = componentName;

OmniBanner.defaultProps = {
  trackOnClose: () => {}
};

OmniBanner.propTypes = {
  onClose: PropTypes.func,
  trackOnClose: PropTypes.func
};

export default OmniBanner;
